export default class {
  constructor () {
    this.$button = document.querySelector('.reservation-end-button')
    this.$sliderbloc = document.querySelector('.reservation__swiper')
    this.$tybloc = document.querySelector('.reservation-thanks')

    // Only hook the legacy inline thanks transition when both blocks exist.
    // Checkout uses the same button class but navigates via Vue + Stripe; there is no .reservation-thanks on that page.
    if (this.$button && this.$sliderbloc && this.$tybloc) {
      this.bindEvents()
    }
  }

  bindEvents () {
    this.$button.addEventListener('click', this.openAnimation.bind(this))
  }

  openAnimation () {
    this.$sliderbloc.classList.add('hidden')
    this.$tybloc.classList.remove('hidden')
  }
}
